import { ReactNode } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DaylitTheme } from '@lendica/theme';

interface StatsCardProps extends BoxProps {
    children: ReactNode;
    align?: 'left' | 'center' | 'right';
}

interface StatsCardContentProps extends BoxProps {
    title: string;
    value: string | number;
    description: string;
    align?: 'left' | 'center' | 'right';
}

export const StatsCard = ({ children, align = 'left', ...props }: StatsCardProps) => {
    return (
        <Box
            {...props}
            sx={{
                // backgroundColor: 'color-mix(in srgb, #FCFCFD, #202024 2%)',
                // border: '1px solid color-mix(in srgb, #FCFCFD, #202024 10%)',
                backgroundColor: DaylitTheme.Palette.Canvas,
                border: `1px solid ${DaylitTheme.Palette.WarmStone}`,
                borderRadius: '8px',
                paddingX: '18px',
                paddingY: '12px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: {
                    xs: 'center',
                    md:
                        align === 'left'
                            ? 'flex-start'
                            : align === 'center'
                            ? 'center'
                            : 'flex-end',
                },
                alignItems: 'center',
                gap: '16px',
                ...props.sx,
            }}
        >
            {children}
        </Box>
    );
};

export const StatsCardContent = ({
    title,
    value,
    description,
    align = 'left',
    ...props
}: StatsCardContentProps) => {
    return (
        <Box
            {...props}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: {
                    xs: 'center',
                    md:
                        align === 'left'
                            ? 'flex-start'
                            : align === 'center'
                            ? 'center'
                            : 'flex-end',
                },
                textAlign: {
                    xs: 'center',
                    md: align,
                },
                gap: '4px',
                flex: {
                    xs: 'auto',
                    md: 1,
                },
                ...props?.sx,
            }}
        >
            <Typography variant="subtitle2" color="text.secondary" fontSize="15px">
                {title}
            </Typography>
            <Typography variant="h4" fontWeight="700">
                {value}
            </Typography>
            <Typography variant="caption" fontSize="13px">
                {description}
            </Typography>
        </Box>
    );
};
